import { useEffect, useRef, useState } from "react";
import { Popover } from "../timeoff/timeOffShared";
import { woStatusUi } from "./woShared";

// Overflow control for a technician/day cell holding more WOs than fit. Shows
// "+N"; clicking lists every WO that day in a popover (mirrors the mockup's
// "Work Orders — March 18" card).
function WoMoreChip({ overflow, all, label, onOpen }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      const inTrigger = ref.current && ref.current.contains(e.target);
      const inPopover = e.target.closest && e.target.closest("[data-timeoff-popover]");
      if (!inTrigger && !inPopover) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  return (
    <>
      <button
        ref={ref}
        onClick={() => setOpen((v) => !v)}
        className="flex items-center justify-center h-[24px] rounded-full px-2 bg-[#EEF0F9] text-[#404040] text-[12px] font-OpenSansSemiBold"
      >
        +{overflow.length}
      </button>
      {open && (
        <Popover anchorRef={ref} width={240}>
          <div>
            <div className="flex items-center justify-between bg-[#F8F9FE] p-3 rounded-t-lg border-b border-[#EEF0F9]">
              <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-[#1A2332] capitalize">
                {label}
              </span>
              <button onClick={() => setOpen(false)} className="opacity-70 hover:opacity-100">
                <img src="/images/common/close.svg" alt="Close" className="w-4 h-4" />
              </button>
            </div>
            <div className="flex flex-col gap-1 p-2">
              {all.map((wo) => {
                const status = woStatusUi(wo.status);
                return (
                  <div
                    key={wo.id}
                    onClick={() => {
                      onOpen?.(wo);
                      setOpen(false);
                    }}
                    className={`flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 hover:bg-[#F8FAFC] ${
                      onOpen ? "hover:cursor-pointer" : ""
                    }`}
                  >
                    <div className="flex flex-col min-w-0">
                      <span className="truncate font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#0058E5]">
                        WO-{wo.number}
                      </span>
                      {wo.customer?.companyName && (
                        <span className="truncate font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-[#7C829A]">
                          {wo.customer.companyName}
                        </span>
                      )}
                    </div>
                    <span
                      className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-OpenSansSemiBold leading-[14px] ${status.chip}`}
                    >
                      {status.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </Popover>
      )}
    </>
  );
}

export default WoMoreChip;
